import React from 'react';
import { Check, Loader } from 'lucide-react';

export type ProgressStep = {
  id: string;
  label: string;
  status: 'waiting' | 'in_progress' | 'completed' | 'error';
};

interface Props {
  steps: ProgressStep[];
}

export default function ProgressSteps({ steps }: Props) {
  return (
    <div className="w-full py-4">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => (
          <React.Fragment key={step.id}>
            {/* Step circle with icon */}
            <div className="flex flex-col items-center">
              <div
                className={`w-8 h-8 flex items-center justify-center rounded-full 
                  ${
                    step.status === 'completed'
                      ? 'bg-green-500'
                      : step.status === 'in_progress'
                      ? 'bg-blue-500'
                      : step.status === 'error'
                      ? 'bg-red-500'
                      : 'bg-gray-200'
                  }`}
              >
                {step.status === 'completed' ? (
                  <Check className="w-5 h-5 text-white" />
                ) : step.status === 'in_progress' ? (
                  <Loader className="w-5 h-5 text-white animate-spin" />
                ) : step.status === 'error' ? (
                  <span className="text-white font-bold">!</span>
                ) : (
                  <span className="text-gray-500">{index + 1}</span>
                )}
              </div>
              {/* Step label */}
              <span
                className={`mt-2 text-xs text-center
                  ${
                    step.status === 'completed'
                      ? 'text-green-600'
                      : step.status === 'in_progress'
                      ? 'text-blue-600'
                      : step.status === 'error'
                      ? 'text-red-600'
                      : 'text-gray-500'
                  }`}
              >
                {step.label}
              </span>
            </div>
            {/* Connector line between steps */}
            {index < steps.length - 1 && (
              <div
                className={`flex-1 h-0.5 mx-2
                  ${
                    step.status === 'completed'
                      ? 'bg-green-500'
                      : 'bg-gray-200'
                  }`}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
